module.exports = __webpack_public_path__ + "static/History Photo-511f756468646c8c011d9fd4fae183bf.jpg";